<template>
  <v-snackbar
    v-model="$store.state.showNotification"
    bottom
    right
    transition="fade-transition"
    color="info"
    :timeout="235000"
    class="fa-font"
  >
    <div style="height: 12px;">
      <v-btn
        class="close-notifications"
        :aria-label="$t('Close')"
        icon
        size="20"
        small
        @click="$store.state.showNotification = false"
      >
        <v-icon
          color="white"
          size="20"
        >
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="notification-content">
      <div
        v-for="item of messages"
        :key="item.message"
        class="pb-2 pr-4"
      >
        <v-avatar
          color="warning"
          class="warning--text"
          size="20"
        >
          <span
            class="white--text"
            style="font-size: 12px"
          >
            {{ item.count }}
          </span>
        </v-avatar>
        {{ item.message }}
      </div>
      <div v-if="returnNotices.length" class="return-notices">
        <strong class="d-block mb-2">{{ $t('ConditionalReturn.NotificationHeading') }}</strong>
        <v-card v-for="notice in returnNotices" :key="'return-' + notice.id" flat outlined class="return-notice mb-2 pa-3">
          <div class="return-notice__title">
            {{ notice.message }}
          </div>
          <div v-if="notice.product_title" class="return-notice__product">
            {{ notice.product_title }}
          </div>
          <router-link
            class="return-notice__link"
            :aria-label="$t('ConditionalReturn.OpenNotifiedCase', { id: notice.return_id }) + ' — ' + $t('ConditionalReturn.Code') + ' ' + notice.code_id"
            :to="{
              name: 'financial-conditional-returns',
              query: {
                bill_id: String(notice.bill_id), return_id: String(notice.return_id), item_id: String(notice.item_id), notice_id: String(notice.id),
              },
            }"
            @click.native="$store.state.showNotification = false"
          >
            {{ $t('ConditionalReturn.OpenNotifiedCase', { id: notice.return_id }) }}
          </router-link>
        </v-card>
      </div>
    </div>
  </v-snackbar>
</template>

<script>
// App Bar Components

import { mdiClose } from '@mdi/js'
import { computed } from '@vue/composition-api'
import store from '@/store'

export default {
  setup() {
    const notifications = computed(() => store.getters.getNotifications)

    const returnNotices = computed(() => notifications.value.conditional_return_notifications || [])

    const messages = computed(() => {
      const text = []
      if (notifications.value.tickets > 0) { text.push({ message: 'تیکت پاسخ داده نشده وجود دارد .', count: notifications.value.tickets }) }
      if (notifications.value.auths > 0) { text.push({ message: ' احراز تایید نشده وجود دارد .', count: notifications.value.auths }) }
      if (notifications.value.manual_send_bills > 0) { text.push({ message: ' فاکتور دستی ارسال نشده وجود دارد.', count: notifications.value.manual_send_bills }) }

      return text
    })

    return {
      messages,
      returnNotices,

      icons: {
        mdiClose,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.close-notifications{
  position: absolute;
  top: 1px;
  right: -1px;
  padding: 0px 19px;
}

.notification-content { max-height: 55vh; overflow-y: auto; padding-top: 8px; }
.return-notices { margin-top: 8px; }
.return-notices > strong { color: #10334a; }
.return-notice { background: #fff !important; }
.return-notice__title { font-size: 13px; line-height: 1.9; color: #403b49; }
.return-notice__product { font-size: 12px; color: #716b7a; margin: 4px 0; }
.return-notice__link { display: inline-block; padding: 6px 0; font-size: 13px; font-weight: 600; color: #b32622 !important; }
</style>
